import { useState, useEffect } from 'react';
import { ISSUE_STATES } from '../pulse.common';
import { LOCAL_STORAGE_KEYS } from 'common/constants/constants';
import _ from 'lodash';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import { mapDataToUiPeopleFilterData } from '../pulse.service';

const usePulseFilters = ({
  selectedContributorIds,
  history,
  selectedTeamContributors,
  rawData
}) => {
  const [issueStateFilterValues, setIssueStateFilterValues] = useState([
    ISSUE_STATES.IN_PROGRESS
  ]);
  const [issueTypeFilterValues, setIssueTypeFilterValues] = useState([]);
  const [searchFilterValue, setSearchFilterValue] = useState('');
  const [searchFilterInitValue, setSearchFilterInitValue] = useState('');
  const [peopleFilterData, setPeopleFilterData] = useState([]);

  const filterByContributors = filtersData =>
    !selectedContributorIds.length ||
    filtersData.contributors.some(c => selectedContributorIds.includes(c));

  const filterDataWithoutContributors = ({ filtersData }) =>
    (!issueStateFilterValues.length ||
      issueStateFilterValues.includes(filtersData.state)) &&
    (!issueTypeFilterValues.length ||
      issueTypeFilterValues.includes(filtersData.type)) &&
    (!searchFilterValue ||
      filtersData.name
        .toLowerCase()
        .includes(searchFilterValue.toLowerCase()) ||
      filtersData.key.toLowerCase().includes(searchFilterValue.toLowerCase()));

  const filterData = ({ filtersData }) =>
    filterDataWithoutContributors({ filtersData }) &&
    filterByContributors(filtersData);

  useEffect(() => {
    const params = new URLSearchParams(_.get(history, 'location.search', ''));
    const searchValue = params.get('query');
    const issueStateValue = params.get('issueState');
    if (searchValue) {
      setIssueStateFilterValues([]);
      setSearchFilterInitValue(searchValue);
      setSearchFilterValue(searchValue);
    } else if (issueStateValue) {
      setIssueStateFilterValues([issueStateValue]);
    }

    BrowserStorageAccessor().local.set(
      LOCAL_STORAGE_KEYS.LAST_VIEW_MAIN_PAGE,
      '/pulse'
    );
  }, []);

  useEffect(() => {
    const peopleFilterData = mapDataToUiPeopleFilterData(
      rawData,
      selectedTeamContributors
    );
    setPeopleFilterData(peopleFilterData);
  }, [rawData, selectedTeamContributors]);

  return [
    issueStateFilterValues,
    issueTypeFilterValues,
    searchFilterInitValue,
    peopleFilterData,
    setPeopleFilterData,
    filterData,
    filterDataWithoutContributors,
    setIssueTypeFilterValues,
    setSearchFilterValue,
    setSearchFilterInitValue,
    setIssueStateFilterValues,
    searchFilterValue
  ];
};

export default usePulseFilters;
